import { useCallback, useEffect, useState } from 'react';
import LandingContext from 'src/contexts/LandingContext/LandingContext';
import Content from 'src/models/content';
import { getLandingContentsService } from 'src/services/landingService';

const LandingContextProvider: React.FC = ({ children }) => {
  const [contents, setContents] = useState([] as Content[]);

  const getContents = useCallback(async () => {
    const { data: contents } = await getLandingContentsService({
      relations: ['authors', 'children'],
    });
    setContents(contents);
  }, []);

  useEffect(() => {
    getContents();
  }, [getContents]);

  return (
    <LandingContext.Provider value={{ contents }}>
      {children}
    </LandingContext.Provider>
  );
};

export default LandingContextProvider;
